import Vue from "vue";
import Vuex from "vuex";
import jwt from "jsonwebtoken";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    authentication: {
      token: null,
      exp: null,
      refreshToken: null //TODO
    },
    user: {
      id: null,
      email: null,
      username: null,
      name: null,
      branch: null,
      is_accounting: false,
      is_full_accounting: false
    }
  },
  getters: {
    token: state => state.authentication.token,
    isAuthenticated: (state /*, getters*/) => {
      return (
        state.authentication.token != null &&
        Date.now() <= state.authentication.exp * 1000
      );
    },
    isAdmin: (state /*, getters */) => {
      return state.user != null && state.user.is_admin;
    },
    isBranchAdmin: (state /*, getters */) => {
      return state.user != null && state.user.is_branch_admin;
    },
    isAccounting: (state /*, getters */) => {
      return state.user != null && state.user.is_accounting;
    },
    isFullAccounting: (state /*, getters */) => {
      return (
        state.user != null &&
        state.user.is_accounting &&
        state.user.is_full_accounting
      );
    },
    userId: state => {
      return state.user != null && state.user.id;
    }
  },
  actions: {
    login(context, data) {
      window.localStorage.setItem("token", data.token);
      var tokenContents = jwt.decode(data.token);
      context.commit("login", {
        authentication: {
          token: data.token,
          exp: tokenContents.exp
        },
        user: {
          id: tokenContents.user_id,
          email: tokenContents.email,
          username: tokenContents.unique_name,
          name: tokenContents.given_name,
          branch: tokenContents.branch_id,
          is_admin: tokenContents.is_admin == "true",
          is_branch_admin: tokenContents.is_branch_admin == "true",
          is_accounting: tokenContents.is_accounting == "true",
          is_full_accounting: tokenContents.is_full_accounting == "true"
        }
      });
    },
    logout(context) {
      window.localStorage.removeItem("token");
      context.commit("logout");
    }
  },
  mutations: {
    login(state, data) {
      state.authentication = data.authentication;
      state.user = data.user;
    },
    logout(state) {
      state.authentication = {};
      state.user = {};
    }
  }
});

var token = window.localStorage.getItem("token");
if (token) {
  store.dispatch("login", {
    token
  });
}

export default store;
